import {concatPath, isEmpty, isNotEmpty} from "./strings";

/**
 * 画像リサイズ用URLを取得
 * @param image_path
 * @param width
 * @param height
 * @returns {string}
 */
// eslint-disable-next-line no-unused-vars
export function imgs(image_path, width, height) {
  const paramStr = image_path + "&w=" + width + "&h=" + height + "&op=";
  // eslint-disable-next-line no-undef
  return concatPath(_IMAGES_DOWNLOAD_URL, paramStr);
}

/**
 * 画像URL作成
 * @param image_path
 * @returns {*|string}
 */
export function img(image_path) {
  if(isNotEmpty(image_path)) {
    // eslint-disable-next-line no-undef
    return concatPath(_IMAGE_DOWNLOAD_URL, image_path);
  } else {
    return null;
  }
}

export function imgSrc(path, width, height) {
  if (isEmpty(width) && isEmpty(height)) {
    return img(path);
  } else {
    // サイズ指定の場合はリサイズする
    return imgs(path, width, height);
  }
}
